export default __webpack_public_path__ + "static/media/indexx.ai_new.ab0feb34.webp";